import Component from "../../lib/component";

export const HvidConfig = {
    componentTypeKey: 'Hvid',
    baseHtmlClass: 'hvid',
    selector: '.hvid',

    datasetConfigKey: 'hvid__config',
};

export class Hvid extends Component {

    static get config() {
        return HvidConfig;
    }

    constructor(id_or_element) {
        super({
            element: id_or_element,
            config: Hvid.config
        });

        this.setDatasetConfig(Hvid.config.datasetConfigKey);

        this.aspectRatio = this.getDatasetConfigValue('aspect_ratio');

        this.iframeElement = this.element.querySelector('iframe');

        this.renderInitial();
    }

    renderInitial() {
        this.element.style.aspectRatio = this.aspectRatio.toString();
        if (this.iframeElement) {
            this.iframeElement.style.width = '100%';
            this.iframeElement.style.height = '100%';
            this.iframeElement.style.display = 'block';
        }

    }

    render() {
    }

}

